/* istanbul ignore file */
import crmActivityValidation from 'domain/sales/shared/timeline/activity/form/crmActivityValidation';
import { ResourceId, useBaseCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

export const UPDATE_CRM_ACTIVITY_PERMISSION = 'CREATE_NOTE';
export const DELETE_CRM_ACTIVITY_PERMISSION = 'CREATE_NOTE';

const useActivityService = () => {
  const { deleteById, update } = useBaseCrudService({
    listResourceUrl: '/crm/activities',
    singleResourceUrl: '/crm/activities/:id',
    useService: useKernelApi,
  });

  const { sendPostRequest } = useKernelApi();

  const addToBlacklist = async (id: ResourceId) => {
    const response = await sendPostRequest(`/crm/activities/${id}/black-list`);

    return response.json();
  };

  return {
    getValidationSchema: () => Promise.resolve(crmActivityValidation),
    deleteById,
    update,
    addToBlacklist,
  };
};

export default useActivityService;
